//
import controlEscolarMachine from "./machine"
import { actionsNoCare } from "../../constants/actionsNoCare"
export const { initialState } = controlEscolarMachine

const ControlEscolar = (state = initialState, action) => {
  //
  if (
    !actionsNoCare.includes(action.type) &&
    !action.type.startsWith("@@") &&
    action.type.startsWith("controlescolar/")
  ) {
    if (!controlEscolarMachine.states[state.value]?.on?.[action.type]) {
      console.error(
        `controlEscolarMachine: No hay transición definida para la acción ${action.type} en el estado ${state.value}`
      )
    } else {
      return controlEscolarMachine.transition(state, action)
    }
  }
  return state
}

export default ControlEscolar
